const filterTypes = {
  ARRAY: 'array',
  BOOLEAN: 'boolean',
  STRING: 'string',
  NUMBER: 'number',
  INT_ARRAY: 'intArray',
};

export { filterTypes };
